export default __webpack_public_path__ + "static/media/TRUCK3.a1f59e41.jpg";